import { render, staticRenderFns } from "./CreateOrUpdateNews.vue?vue&type=template&id=57f756e8&"
import script from "./CreateOrUpdateNews.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports